import sanitizeHtml from 'sanitize-html';

export const sanitizeAndDecodeHtml = (inputString?: string | null): string =>
    sanitizeHtml(inputString || '', { allowedTags: [] })
        .replace(/&amp;/g, '&')
        .replace(/&apos;/g, "'")
        .replace(/&quot;/g, '"');
